module.exports = __webpack_public_path__ + "static/media/BgLoginCard.7b43b2e6.png";